<style>
</style>

<template>
    <div class="animated fadeIn">
        <b-tabs fill>
            <b-tab @click="changeTab('signatures')">
                <template slot="title">
                    <i class="fa fa-pencil mr-2"></i>{{Core.Definition.getDefinition('Signatures')}}
                </template>
                <b-row>
                    <b-col>
                        <BinderPDFSignatureContainer></BinderPDFSignatureContainer>
                    </b-col>
                </b-row>
            </b-tab>
            <b-tab @click="changeTab('stamps')">
                <template slot="title">
                    <i class="fa fa-image mr-2"></i>{{Core.Definition.getDefinition('Étampes')}}
                </template>
                <b-row>
                    <b-col>
                        <BinderPDFStampContainer></BinderPDFStampContainer>
                    </b-col>
                </b-row>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
    import Vue from 'vue'
    Vue.use(require('vue-moment'))
    import BinderPDFSignatureContainer from '../../containers/BinderPDFSignatureContainer'
    import BinderPDFStampContainer from '../../containers/BinderPDFStampContainer'
    export default {
        name: 'SettingsBinder',
        components: {
            BinderPDFSignatureContainer,
            BinderPDFStampContainer
        },
        watch: {
        },
        mounted() {
            this.changeTab('signatures')
        },
        data: function () {
            return {
                Core: window.Core,
                Mantle: window.Mantle,
                dataCurrentTab: ''
            }
        },
        computed: {
        },
        methods: {
            changeTab(tab) {
                if (this.dataCurrentTab !== tab) {
                    switch(tab) {
                        case 'signatures':
                            this.$router.push('/systeme/parametres/classeur/signatures')
                            break
                        case 'stamps':
                            this.$router.push('/systeme/parametres/classeur/etampes')
                            break
                    }
                    this.dataCurrentTab = tab
                }
            }
        }
    }
</script>
